import ArchiveContent from './ArchiveContent'

export default ArchiveContent
